import React, { useState, useEffect } from 'react';
import { formatDateTime } from '../Shared/Text';
import { toastDiv, toastFail, defaultH3Text, boldLabel, subSectionMinHeight, subSectionTitle, tableHeaderText, tableBodyOddRow, tableBodyEvenRow, tableBodyDownloadLink } from '../Shared/Styles';
import PaginationButtons from '../../components/Shared/PaginationButtons';
import ToastMessage from '../../components/Shared/ToastMessage';
import GetCorrespondences from '../../services/GetCorrespondences';
import Spinner from '../../components/Spinner/Spinner';
import DownloadCorrespondence from '../../services/DownloadCorrespondence';
import { useLocation} from "react-router-dom";
import { GelColumnLayout, GelRowLayout, GelContainerLite, GelBoxLayout} from '@tal-gel/components';

function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  export default function ViewCorrespondence(props) {
    let query = useQuery();
    const [totalDocumentsCount, setTotalDocumentsCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [correspondencesData, setCorrespondencesData] = useState([]);
    const [failToastMessage, setfailToastMessage] = useState(false);
    const [loading, setLoading] = useState(false);
    const togglefailToastMessage = () => setfailToastMessage(!failToastMessage);
   
    const [policyNumber] = useState(query.get("policyNumber"));
    const [distributorNo] = useState(query.get("distributorNo"));
    const [sourceSystem] = useState(query.get("sourceSystem"));

    async function retrieveCorrespondences() {

        try {
            setLoading(true)
            const result = await GetCorrespondences(
                policyNumber,
                distributorNo,
                sourceSystem
            );
    
            if (result !== undefined) {
                setTotalDocumentsCount(result.sharepointDocsList.length);
                setCorrespondencesData(result.sharepointDocsList);
            }
            else {
                throw Error(result.statusText);
            }
        } 
        catch (error) {
            setfailToastMessage(true);
        } 
        finally {
            setLoading(false);
        }
    }

    const getFileExtension = (item) =>{
        if (item && item.fileExt === 'eml') {
            return 'pdf';
        }
        else{
            return item.fileExt;
        }
    };

    async function downloadCorrespondences (correspondence) {

        try {
            const result = DownloadCorrespondence(
                correspondence
            );
        } 
        catch (error) {
        
        } 
        finally {
           
        }
    }

    const convertToLocalTimeZone = (indexDate) => {
        if (indexDate) {
            var newDate = new Date(Date.parse(indexDate) - 11 * 3600 * 1000);
            return newDate;
        }
    };

  
    useEffect(() => {
        try {
            retrieveCorrespondences();
        }
        catch (error) {
            return (<div>error</div>);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, pageSize]); // useEffect hook to currentPage state

    return (
        <GelContainerLite style={subSectionMinHeight}>
            <Spinner loading={loading} />
            <hr />
            <GelRowLayout gutter="medium" style={subSectionTitle}>
                <h3 style={defaultH3Text} data-testid="correspondenceLabel">Correspondence on policy {policyNumber}</h3>
            </GelRowLayout>
            <GelRowLayout gutter="medium" style={tableHeaderText}>
                <GelBoxLayout space={[5,2,1]}>
                    <div style={boldLabel}>Correspondence</div>
                    <div style={boldLabel}>Type of Doc</div>
                    <div style={boldLabel}>Date Requested</div>
                </GelBoxLayout>
            </GelRowLayout>
            {(correspondencesData.length === 0 && !loading) ?
                <GelRowLayout gutter="medium">
                    <GelColumnLayout style={tableBodyEvenRow}>
                    <div data-testid="correspondenceNoDocumentTitle">
                    There are currently no correspondence documents to display.
                    </div>
                    </GelColumnLayout>
                </GelRowLayout>
                : correspondencesData.map((cd, index) =>
                    <div key={index}>
                        <GelRowLayout gutter="medium" style={(index % 2 === 0) ? tableBodyEvenRow : tableBodyOddRow}>
                            <GelBoxLayout space={[5,2,1]}>
                                <div data-testid="correspondenceTitle">
                                  <a href="#" onClick={() =>downloadCorrespondences(cd)} target="_self">{cd.title}</a>
                                </div>
                                <div data-testid="correspondenceType">
                                    {getFileExtension(cd)}
                                </div>
                                <div data-testid="correspondenceTypeDate">
                                    {formatDateTime(cd.indexDate)}
                                   
                                </div>
                            </GelBoxLayout>
                        </GelRowLayout>
                    </div>
                )}

            <PaginationButtons totalCount={totalDocumentsCount} pageSize={pageSize} setPageSize = {setPageSize} currentPage={currentPage} setCurrentPage={setCurrentPage}></PaginationButtons>

            <div style={toastDiv}>
                <ToastMessage
                    toggleToast={togglefailToastMessage}
                    toastType={toastFail}
                    showToast={failToastMessage}
                    message={'Failed to retrieve documents. Please try again.'} />
            </div>
        </GelContainerLite>
    );
}